const themeEnum = {
    TOURNAMENT: 1,
    TEAMGAME: 2,
    LOBBY: 3,
};

Object.freeze(themeEnum);

export default themeEnum;
